export default {
  kiosk: {
    温馨提示: "溫馨提示",
    继续点餐: "繼續點餐",
    长时间未操作: "長時間未操作, {second} S後自動返回首頁",
    数据加载中: "數據加載中...",
  },
};
